
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.984 0C7.175 0 0 7.175 0 15.984 0 24.825 7.175 32 15.984 32 24.793 32 32 24.825 32 15.984 32 7.175 24.793 0 15.984 0zm10.923 23.544c-3.491.384-7.271.48-10.923.48s-7.431-.096-10.955-.48c-.993-.096-1.506-.353-1.634-1.41-.192-2.018-.192-4.068-.192-6.15 0-2.05 0-4.1.192-6.118.128-1.057.64-1.313 1.634-1.41 3.523-.384 7.303-.48 10.955-.48 3.651 0 7.431.096 10.923.48 1.025.096 1.537.353 1.665 1.41.16 2.018.16 4.068.16 6.118 0 2.082 0 4.132-.16 6.15-.128 1.057-.64 1.313-1.665 1.41z","fill":"url(#paint0_linear_581_5748)"}}),_c('path',{attrs:{"d":"M9.513 15.984a6.452 6.452 0 016.47-6.47 6.452 6.452 0 016.47 6.47c0 3.556-2.818 6.503-6.47 6.503-3.651 0-6.47-2.947-6.47-6.503z","fill":"url(#paint1_linear_581_5748)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_581_5748","x1":"-1.208","y1":"11.872","x2":"140.474","y2":"45.891","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#00E074"}}),_c('stop',{attrs:{"offset":".298","stop-color":"#00E074"}}),_c('stop',{attrs:{"offset":".658","stop-color":"#19981E"}}),_c('stop',{attrs:{"offset":".999","stop-color":"#008F4A"}})]),_c('linearGradient',{attrs:{"id":"paint1_linear_581_5748","x1":"-1.208","y1":"11.872","x2":"140.474","y2":"45.892","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#00E074"}}),_c('stop',{attrs:{"offset":".298","stop-color":"#00E074"}}),_c('stop',{attrs:{"offset":".658","stop-color":"#19981E"}}),_c('stop',{attrs:{"offset":".999","stop-color":"#008F4A"}})])])])
          )
        }
      }
    